import React, { useState } from "react";
import icochevrondown from "../assets/scenariobar/flecha-scenario-bar-down.svg";
import icochevronup from "../assets/scenariobar/flecha-scenario-bar-up.svg";
import icocompleted from "../assets/scenariobar/ico-completed.svg";
import icoLockClosed from "../assets/candado-cerrado.svg";
import icoLockOpenedWhite from "../assets/candado-abierto-blanco.svg";
import candadoOpenOrange from "../assets/scenariobar/candado-open-orange.svg";
import candadoOpenViolet from "../assets/scenariobar/candado-open-violet.svg";
import candadoOpenBlue from "../assets/scenariobar/candado-open-blue.svg";
import candadoOpenGreen from "../assets/scenariobar/candado-open-green.svg";

function ScenarioBar({ activeScenario, expanded, onScenarioClick }) {
	const [scenarioBarOpen, setScenarioBarOpen] = useState(expanded || false);

	function handleClick(e) {
		if (!scenarioBarOpen) setScenarioBarOpen(true);
		else setScenarioBarOpen(false);
	}

	const getClasses = (idx) => {
		if (idx < activeScenario) return "";
		else if (idx === activeScenario) return "bold";
		else if (idx > activeScenario) return "gray";
		return "";
	};

	const getIcon = (idx) => {
		if (idx <= activeScenario) {
			switch (idx) {
				case 2:
					return candadoOpenOrange;
					break;
				case 3:
					return candadoOpenViolet;
					break;
				case 4:
					return candadoOpenBlue;
					break;
				case 5:
					return candadoOpenGreen;
					break;
				default:
					break;
			}
		}
		return icoLockClosed;
	};

	const canNavigateTo = (idx) => idx === activeScenario && typeof onScenarioClick === "function";

	const handleScenarioBoxClick = (idx) => {
		if (canNavigateTo(idx)) onScenarioClick(idx);
	};

	const scenarioBoxProps = (idx) => {
		const active = idx === activeScenario;
		return {
			role: canNavigateTo(idx) ? "button" : "img",
			"aria-disabled": !canNavigateTo(idx),
			onClick: () => handleScenarioBoxClick(idx),
			style: canNavigateTo(idx) ? { cursor: "pointer" } : undefined,
		};
	};

	return (
		<div
			className={
				scenarioBarOpen
					? "scenarioBar py-2 px-3 active"
					: "scenarioBar py-2 px-3 inactive"
			}
		>
			<div className="buttonDown" onClick={handleClick}>
				{scenarioBarOpen && (
					<img src={icochevrondown} alt="Esconder menú" />
				)}
				{!scenarioBarOpen && (
					<img src={icochevronup} alt="Mostrar menú" />
				)}
			</div>
			<div className="row h-100 align-items-center">
				{!scenarioBarOpen && (
					<div className="scenarioIndicator">Escenarios</div>
				)}


				<div className="col px-2">
					<div
						className={`scenarioBox diagnostico ${getClasses(2)} d-flex align-items-center justify-content-center`}
						{...scenarioBoxProps(2)}
					>
						<div className="lock">
							<img src={getIcon(2)} className="iconlock" />
						</div>
						<div
							className="text-center"
							style={{ maxWidth: "96%", zIndex: 10000 }}
						>
							<div className="mt-1">Diagnóstico</div>
						</div>
					</div>
				</div>
				<div className="col px-2">
					<div
						className={`scenarioBox tratamiento ${getClasses(3)} d-flex align-items-center justify-content-center`}
						{...scenarioBoxProps(3)}
					>
						<div className="lock">
							<img src={getIcon(3)} className="iconlock" />
						</div>
						<div
							className="text-center"
							style={{ maxWidth: "96%", zIndex: 10000 }}
						>
							<div className="mt-1">
								Estratificación
							</div>
						</div>
					</div>
				</div>
				<div className="col px-2">
					<div
						className={`scenarioBox eventos-adversos ${getClasses(4)} d-flex align-items-center justify-content-center`}
						{...scenarioBoxProps(4)}
					>
						<div className="lock">
							<img src={getIcon(4)} className="iconlock" />
						</div>
						<div
							className="text-center"
							style={{ maxWidth: "96%", zIndex: 10000 }}
						>
							<div className="mt-1">
								Tratamiento
							</div>
						</div>
					</div>
				</div>
				<div className="col px-2">
					<div
						className={`scenarioBox evidencia ${getClasses(5)} d-flex align-items-center justify-content-center`}
						{...scenarioBoxProps(5)}
					>
						<div className="lock">
							<img src={getIcon(5)} className="iconlock" />
						</div>
						<div
							className="text-center"
							style={{ maxWidth: "96%", zIndex: 10000 }}
						>
							<div className="mt-1">
								Seguimiento
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export default ScenarioBar;
